import React from "react";
import {
    Flex,
    Text,
    Box,
    Heading,
    VStack,
    HStack,
    Icon,
} from "@chakra-ui/react";
import { FaUsers, FaChartBar, FaLock, FaTasks, FaEnvelope, FaMobile } from "react-icons/fa";

const OverviewPage = () => {
    console.log("OverviewPage component rendered successfully");

    try {
        return (
            <Box p={6} minH="80vh">
                <Heading as="h1" size="xl" color="gray.700" mb={6}>
                    Getting Started
                </Heading>

                <VStack spacing={6} align="stretch">
                    <Text fontSize="lg" color="gray.600" mb={4}>
                        Here's everything you need to know to get started with managing your customer relationships effectively.
                    </Text>

                    <Box bg="blue.50" p={6} borderRadius="lg" border="1px solid" borderColor="blue.200">
                        <Heading as="h2" size="lg" color="blue.700" mb={4}>
                            CRM Activities Overview
                        </Heading>
                        <VStack spacing={4} align="stretch">
                            <HStack>
                                <Icon as={FaUsers} color="blue.500" />
                                <Text color="gray.700">
                                    <strong>Contact Management:</strong> Organize and maintain detailed customer profiles, track interactions, and manage your entire contact database in one centralized location.
                                </Text>
                            </HStack>
                            <HStack>
                                <Icon as={FaTasks} color="blue.500" />
                                <Text color="gray.700">
                                    <strong>Sales Pipeline:</strong> Track leads through every stage of your sales process, from initial contact to closed deals, ensuring no opportunity is missed.
                                </Text>
                            </HStack>
                            <HStack>
                                <Icon as={FaEnvelope} color="blue.500" />
                                <Text color="gray.700">
                                    <strong>Email Integration:</strong> Send, receive, and track emails directly within the CRM, maintaining a complete communication history with each contact.
                                </Text>
                            </HStack>
                            <HStack>
                                <Icon as={FaMobile} color="blue.500" />
                                <Text color="gray.700">
                                    <strong>Task Automation:</strong> Set up automated workflows, reminders, and follow-ups to streamline your daily activities and never miss important tasks.
                                </Text>
                            </HStack>
                        </VStack>
                    </Box>

                    <Box bg="green.50" p={6} borderRadius="lg" border="1px solid" borderColor="green.200">
                        <Heading as="h2" size="lg" color="green.700" mb={4}>
                            Reporting & Analytics
                        </Heading>
                        <VStack spacing={3} align="stretch">
                            <HStack>
                                <Icon as={FaChartBar} color="green.500" />
                                <Text color="gray.700">
                                    Generate comprehensive reports on sales performance, customer engagement, and team productivity to make data-driven decisions.
                                </Text>
                            </HStack>
                            <Text color="gray.700" pl={6}>
                                • Track conversion rates and sales metrics<br />
                                • Monitor customer interaction patterns<br />
                                • Export data for external analysis and presentations
                            </Text>
                        </VStack>
                    </Box>

                    <Box bg="orange.50" p={6} borderRadius="lg" border="1px solid" borderColor="orange.200">
                        <Heading as="h2" size="lg" color="orange.700" mb={4}>
                            Security & Password Management
                        </Heading>
                        <VStack spacing={3} align="stretch">
                            <HStack>
                                <Icon as={FaLock} color="orange.500" />
                                <Text color="gray.700">
                                    Your data security is our top priority. Our CRM includes robust password protection and user access controls.
                                </Text>
                            </HStack>
                            <Text color="gray.700" pl={6}>
                                • Role-based access control to limit data visibility<br />
                                • Encrypted data storage and secure backup systems<br />
                            </Text>
                        </VStack>
                    </Box>

                    <Box bg="purple.50" p={6} borderRadius="lg" border="1px solid" borderColor="purple.200">
                        <Heading as="h2" size="lg" color="purple.700" mb={4}>
                            Getting Support
                        </Heading>
                        <Text color="gray.700">
                            Need help getting started? Visit our FAQ section or contact our support team for personalized assistance.
                            We're here to help you maximize your CRM experience and boost your productivity.
                        </Text>
                    </Box>
                </VStack>
            </Box>
        );
    } catch (error) {
        console.error("Error in OverviewPage component:", error);
        return (
            <Box p={6}>
                <Text color="red.500">Error loading Getting Started page</Text>
            </Box>
        );
    }
};

export default OverviewPage;